import React, { useState } from 'react'
import { ProjectList } from '../../common/interface';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { formatTimeWithSecond } from '../../Pages/ProjectListPage';
import { selectedProjectType } from '../../store/projectSlice';
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

interface ProjectAccordianItemProps {
    project: any;
    level: number;
    selectedProject: selectedProjectType | null;
    handleProjectSelection: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, project: ProjectList) => void;
}

const ProjectAccordianItem: React.FC<ProjectAccordianItemProps> = ({ project, level, selectedProject, handleProjectSelection }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, project: ProjectList) => {
        event.stopPropagation();
        handleProjectSelection(event, project);
    }

    return (
        <div className={`project `} onClick={(event) => handleClick(event, project)}>
            <div className={`${selectedProject?.id === project.id ? "active" : ""} project_details`} style={{ paddingLeft: `${level * 8}px` }}>
                <div className="project_name_wrapper">
                    <span className="project_play_icon">
                        {project.id === selectedProject?.id && <PlayCircleIcon fontSize="small" color="primary"></PlayCircleIcon>}
                    </span>
                    <p
                        className="project_name"
                        title={project.name}
                    >
                        {project.name}
                    </p>
                </div>
                <div className="project_spent_time_wrapper">
                    <p className="project_spent_time">{formatTimeWithSecond(project?.projectSpentTimeInsecond || 0)}</p>
                    {project.subProjects && project.subProjects.length > 0 ? (
                        <p
                            className="project_toggle_wrapper"
                            onClick={(event) => {
                                event.stopPropagation();
                                setIsOpen(!isOpen);
                            }}
                        >
                            {isOpen ? <KeyboardArrowDownIcon sx={{ fontSize: 25 }} /> : <ChevronRightIcon sx={{ fontSize: 25 }} />}
                        </p>
                    ) : <div className="empty_children"></div>}
                </div>
            </div>
            {isOpen && project.subProjects && project.subProjects.length > 0 && (
                <div className="project_children">
                    {project.subProjects.map((subProject: ProjectList, index: number) => (
                        <ProjectAccordianItem
                            key={index}
                            project={subProject}
                            level={level + 1}
                            selectedProject={selectedProject}
                            handleProjectSelection={handleProjectSelection}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export default ProjectAccordianItem;